export default class {
	static getDeviceWidth(deviceJson) {
		if (deviceJson.device === 'desktop') {
			return 1200;
		} else if (deviceJson.device === 'other') {
			return 800;
		}
		return 200;
	}
	
	static formatDate(date) {
		const day = getOrdinalNum(date.getDate());
		const month = getMonthName(date.getMonth());
		const year = date.getFullYear();
		return `${day} ${month}, ${year}`;
	}
}

function getOrdinalNum(n) {
	return n + (n > 0 ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10] : '');
}

function getMonthName(n) {
	const monthList = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	return monthList[n];
}
